import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid } from '@iho-design-system/Loader';

/*
    - icons
*/
import RequestSVG from '../../assets/images/help-desk/request.svg';
import FollowUpSVG from '../../assets/images/help-desk/follow-up.svg';

const TabList = ({ requestType, toggleTabProps }) => {

    /*
        - loadDashboard
    */
    const loadDashboard = () => {
        window.location.href = 'https://www.iranhotelonline.com/Persian/UserProfile/#/request';
    }

    return (

        <React.Fragment>

            {requestType === '' &&
                <Box
                    className={`w-100 my-lg mb-0`}>
                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                className={`pr-0`}
                                size='col-6'>
                                <Button
                                    onClick={() => toggleTabProps('newRequest')}
                                    iconStart={RequestSVG}
                                    ms={{
                                        width: '100%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: '#ffffff !important',
                                        border: '1px solid var(--gray-medium)'
                                    }}>
                                    درخواست جدید
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                className={`pl-0`}
                                size='col-6'>
                                <Button
                                    onClick={() => loadDashboard()}
                                    iconStart={FollowUpSVG}
                                    ms={{
                                        width: '100%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: '#ffffff !important',
                                        border: '1px solid var(--gray-medium)'
                                    }}>
                                    پیگیری درخواست‌ها
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Box>
            }
            {requestType.split(',')[0] === 'newRequest' && requestType.split(',')[2] === undefined &&
                <Box
                    className={`d-flex flex-wrap my-lg mb-0`}
                    ms={{
                        width: '100%',
                        gap: 'var(--sizing-xs)',
                        '@keyframes tabAnimation': {
                            'from': {
                                opacity: '0',
                            },
                            'to': {
                                opacity: '1',
                            }
                        }
                    }}>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('modifyRoom')}
                            size='sm'
                            ms={{
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            تغییر یا حذف اتاق
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.1s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('cancel')}
                            size='sm'
                            ms={{
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            کنسل کردن رزرو
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.2s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('modifyDate')}
                            size='sm'
                            ms={{
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            تغییر تاریخ اقامت
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.3s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('extraPassenger')}
                            size='sm'
                            ms={{
                                flexGrow: '1',
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            افزودن نفر اضافه
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.4s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('halfCharge')}
                            size='sm'
                            ms={{
                                flexGrow: '1',
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            افزودن نیم شارژ
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.5s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('hotelInfo')}
                            size='sm'
                            ms={{
                                flexGrow: '1',
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            اطلاعات هتل
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.6s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('modifyPassenger')}
                            size='sm'
                            ms={{
                                flexGrow: '1',
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            تغییر اطلاعات مسافر
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.7s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('invoice')}
                            size='sm'
                            ms={{
                                flexGrow: '1',
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            فاکتور رسمی
                        </Button>
                    </Box>
                    <Box
                        ms={{
                            flexGrow: '1',
                            width: '25%',
                            opacity: '0',
                            animation: 'tabAnimation 0.5s linear',
                            animationDelay: '1.8s',
                            animationFillMode: 'forwards'
                        }}>
                        <Button
                            onClick={() => toggleTabProps('transfer')}
                            size='sm'
                            ms={{
                                flexGrow: '1',
                                width: '100%',
                                fontSize: '85%',
                                color: 'var(--gray-dark) !important',
                                backgroundColor: 'var(--white) !important',
                                border: '1px solid var(--gray-medium)',
                                '&:hover': {
                                    backgroundColor: 'var(--gray-light) !important'
                                }
                            }}>
                            ترنسفر
                        </Button>
                    </Box>
                </Box>
            }

        </React.Fragment>

    );

}

export default TabList;